import google from './google'
import categoryMenu from './categoryMenu'
import tradeMenu from './tradeMenu'
import faq from './faq'
import regulation from './regulation'
import terms from './terms'
import footerMenu from './footerMenu'
import meta from './meta'

const menu = process.env.REACT_APP_FULL_MENU

export default {
  mainMenu: menu || {
    default: { tradeMenu, categoryMenu, footerMenu, faq, regulation, terms }
  },
  google,
  metadata: meta
}



// WEBPACK FOOTER //
// ./src/redux/initial-state/index.js